import { useEffect, useState } from "react"
import { useTheme } from "@emotion/react"
import type { IndeedTheme } from "@indeed/ifl-themes"
import { useWindowWidth } from "./useWindowWidth"

export const useIsMobile = (): boolean => {
    const { breakpoints } = useTheme() as IndeedTheme
    const windowWidth = useWindowWidth()
    // breakpoint values could be strings or numbers so we need to account for both
    // they come in terms of 'rem' which we can multiply by 16 to get values in px's
    const mobileBreakpoint = typeof breakpoints[0] === "string" ? parseInt(breakpoints[0], 10) * 16 : breakpoints[0] * 16
    const [isMobile, setIsMobile] = useState(windowWidth <= mobileBreakpoint)

    useEffect(() => {
        setIsMobile(windowWidth <= mobileBreakpoint)
    }, [windowWidth, mobileBreakpoint])

    return isMobile
}
